import React from "react";
import { useEffectAsync } from "../reactHelper";

import PositionsMap from "./PositionsMap";

const CurrentPositionsMap = ({ accessToken }) => {
  // const positions = useSelector(state => Object.values(state.positions.items));
  const [positions, setPositions] = React.useState([]);
  const fetchData = async () => {
    const response = await fetch(
      `/api/liveLocation/getDevicesInfo?accessToken=${accessToken}`
    );
    if (response.ok) {
      const dataResponse = await response.json();
      if (!dataResponse.successful) {
        alert(dataResponse.message);
      }
      setPositions(dataResponse.object);
      // dispatch(devicesActions.refresh(await response.json()));
    }
  };

  useEffectAsync(async () => {
    fetchData();
    const interval = setInterval(() => {
      !document.hidden && fetchData();
    }, 15000);
    return () => clearInterval(interval);
  }, [accessToken]);
  const newPos = (positions && positions[0] && [positions[0]]) || [];
  return <PositionsMap positions={positions} />;
};

export default CurrentPositionsMap;
